import { render, staticRenderFns } from "./SlideAnalyticsModal.vue?vue&type=template&id=95c887bc&scoped=true"
import script from "./SlideAnalyticsModal.vue?vue&type=script&lang=js"
export * from "./SlideAnalyticsModal.vue?vue&type=script&lang=js"
import style0 from "./SlideAnalyticsModal.vue?vue&type=style&index=0&id=95c887bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c887bc",
  null
  
)

export default component.exports